import posthog from "posthog-js";
import { getUser } from "./userHelpers";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_ENABLED = process.env.REACT_APP_POSTHOG_ENABLED === "true";

const resolveUserProps = (user) => {
  if (!user) return null;
  const id = user.user_id || user.localId;
  if (!id) return null;
  return {
    id,
    email: user.email,
    name: user.first_name || user.firstName || user.displayName,
  };
};

if (POSTHOG_KEY && POSTHOG_ENABLED) {
  posthog.init(POSTHOG_KEY, {
    api_host: "https://us.i.posthog.com",
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    person_profiles: "always",
    session_recording: {
      recordCrossOriginIframes: true,
    },
  });

  const props = resolveUserProps(getUser());
  if (props) {
    posthog.identify(props.id, {
      email: props.email,
      name: props.name,
    });
  }
}

export { resolveUserProps };

export const resetPosthog = () => {
  posthog.reset();
};

export default posthog;
